export function normalizeSecureStoreKeyPart(value: string) {
  const normalized = value.replace(/[^\w.-]/g, '_');
  return normalized || '_';
}

export function createSecureStoreKey(
  prefix: string,
  ...parts: (string | null | undefined)[]
) {
  const keyParts = [
    normalizeSecureStoreKeyPart(prefix),
    ...parts
      .filter((part): part is string => typeof part === 'string' && part.length > 0)
      .map(normalizeSecureStoreKeyPart),
  ];

  return keyParts.join('.');
}
